// src/App.js
import React, { useEffect } from 'react'; // Добавляем useEffect
import { Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import MainPage from './pages/MainPage';
import AboutPage from './pages/AboutPage';
import TeamPage from './pages/TeamPage';
import StatusPage from './pages/StatusPage';

import AOS from 'aos';         // 1. Импортируем AOS
import 'aos/dist/aos.css';  // 2. Импортируем стили AOS

function App() {
    useEffect(() => {
        // 3. Инициализируем AOS
        AOS.init({
            duration: 700, // Длительность анимации в миллисекундах
            once: true,    // Анимация должна произойти только один раз (при первом появлении)
            offset: 50,    // Смещение (в px) от оригинальной точки триггера анимации
            // easing: 'ease-in-out', // Тип замедления (можно выбрать другой)
            // delay: 100, // Глобальная задержка для всех анимаций (можно переопределить для каждого элемента)
        });
    }, []); // Пустой массив зависимостей, чтобы useEffect выполнился один раз при монтировании

    return (
        <>
            <Navbar />
            <Routes>
                <Route path="/" element={<MainPage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/team" element={<TeamPage />} />
                <Route path="/status" element={<StatusPage />} />
            </Routes>
        </>
    );
}

export default App;